import React from 'react'
import { useAuth } from '../Auth/Core'
import { LockKeyhole } from 'lucide-react'

type Props = {}

const RenderData = ({ value }: { value: string | undefined }) => {
    const { currentUser } = useAuth()
    return currentUser ? <span>{value || "-"}</span> : <div className='bg-white p-2 rounded-md '><LockKeyhole size={14} /></div>
}

export default RenderData